module.exports = __webpack_public_path__ + "static/ebara-e-6e418412305898e3baf8b64b144c2f28.svg";